import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Base styles first, so component stylesheets can override them. Importing
// App before this puts every component's CSS earlier in the bundle, and base
// rules then win ties against component rules of equal specificity - which is
// how the desktop-only header button ended up showing on mobile.
import "./styles/global.css";
import { App } from "./App.tsx";

const container = document.getElementById("root");
if (!container) throw new Error("Missing #root element");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
